// Default content type used for images
export const DefaultImageContentType = 'image/jpeg';

/**
 * Image thumbnail sizes
 */
export enum ImageThumbnailSize {
  // 100 x 100
  XS = 'xs',
  // 300 x 300
  S = 's',
  // 600 x 600
  M = 'm',
  // 1200 x 1200
  L = 'l',
  // 1920 x 1920
  XL = 'xl',
  ORIG = 'original', // Original image
  OPTIMIZED = 'optimized', // JPEG compressed image, same resolution as original image
}

/**
 * Image anonymization types.
 */
export enum ImageAnonymizationType {
  // Upscale -> Downscale -> Flop
  UDF = 'udf',

  // Normalize -> Sharpen
  NS = 'ns',
}
